import { backofficeApiUrls } from 'apis/BackofficeAPI';
import useSWR, { invalidate as mutate } from 'hooks/useSWR';
import { List } from 'types/api';
import { CommunityConfiguration, TinyCommunity } from 'types/company/community';
import { UserProfile } from 'types/user';
import { useSWRResource } from 'util/resource/useSWRResource';

export interface BackofficeCommunity {
  details: TinyCommunity;
  configuration: CommunityConfiguration;
  isTestCommunity: boolean;
  isPlatformApproved?: boolean;
  imageURL?: string;
  previewMessage?: string;
  description?: string;
  contactPerson?: UserProfile;
}

export const useBackofficeCommunities = () => {
  const swrResult = useSWR<List<BackofficeCommunity>>(backofficeApiUrls.communities.list);
  return useSWRResource(swrResult);
};

export const invalidate = () => mutate(backofficeApiUrls.communities.list);
